module.exports = __webpack_public_path__ + "img/108-35-flat.b3b1546a.jpg";